import { RoleName } from '.'

export const extractRoleNames = (
  userRoles: RoleName[] | { name: RoleName; id: number }[],
): RoleName[] => userRoles.map((role) => (typeof role === 'string' ? role : role.name))

export const hasMatchingRoles = (userRoles: RoleName[], matchingRoles: Set<RoleName>) =>
  userRoles.some((role) => matchingRoles.has(role))

export const getRoleDescription = (role: RoleName): string => {
  return `role.description.${role}`
}
